import { BrandLogo, useBrand } from "@/brand";

const Footer = () => {
  const { email } = useBrand();

  return (
    <footer id="fin" className="bg-[var(--gm-deep)] text-[var(--gm-on-deep)] py-16" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid md:grid-cols-3 gap-12">
        <div>
          <BrandLogo size="sm" showTagline={false} reverse />
          <p className="mt-4 text-sm font-light text-[var(--gm-faint)] leading-relaxed">
            Despacho jurídico con más de 20 años de trayectoria en Puebla, México.
          </p>
        </div>
        <div className="text-sm font-light text-[var(--gm-faint)] leading-relaxed">
          <p className="text-xs tracking-[0.25em] uppercase text-[var(--gm-on-deep)] mb-4">Oficina</p>
          <p>Calzada Zavaleta No. 4710, Piso 9, Int. 4</p>
          <p>Torre Llum, C.P. 72176, Puebla, Pue.</p>
          <p className="mt-3">
            <a href={`mailto:${email}`} className="hover:text-[var(--gm-on-deep)] transition-colors">
              {email}
            </a>
          </p>
          <p>+52 222 426 5873 · +52 222 861 6693</p>
        </div>
        <div className="text-sm font-light text-[var(--gm-faint)] leading-relaxed md:text-right">
          <p className="text-xs tracking-[0.25em] uppercase text-[var(--gm-on-deep)] mb-4">Legal</p>
          <p>© {new Date().getFullYear()} Guillermo Morales Rodríguez</p>
          <p className="mt-6 inline-flex items-center gap-2 text-xs tracking-wide" data-testid="powered-by-jada">
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--gm-accent)]" />
            Powered by <span className="font-semibold text-[var(--gm-accent)]">JADA</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
